import React from 'react';
import ModalDialog from '../AlmeDialog/ModalDialog';
import DataCollectionPane from './DataCollectionPane';
import { feedbackAppEventParam } from './FeedbackAppEventParam';
const FeedbackFormOverlay = (props) => {
    const onSubmit = async (values, isCompleted) => {
        const appEventParams = feedbackAppEventParam(props.responseAction.Metadata.chatFormPanes[0].paneId, isCompleted, Object.assign(Object.assign({}, values), { returnAppEventParam: props.responseAction.Metadata.chatFormPanes[0].metadata.returnAppEventParam }));
        await props.onFeedbackFormSubmit('CloseForm', appEventParams, 'Internal');
    };
    return (React.createElement(ModalDialog, { id: 'data-collection-dialog', ariaLabel: 'Data collection dialog', ariaDescribedBy: "data-collection-dialog-title" },
        React.createElement(DataCollectionPane, { metadata: props.responseAction.Metadata.chatFormPanes[0], onSubmit: onSubmit })));
};
export default FeedbackFormOverlay;
